"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WalletApiCryptoCurrencies = exports.Currencies = exports.CryptoCurrencies = exports.CryptoTokens = exports.Fiats = exports.PolygonTokens = exports.TronTokens = exports.BscTokens = exports.EthTokens = exports.Coins = void 0;
const definitions_1 = require("@ppay/definitions");
const coins_1 = require("./coins");
const logo_1 = require("./logo");
const network_1 = require("./network");
exports.Coins = [
    {
        name: 'Bitcoin',
        ticker: definitions_1.Ticker.BTC,
        type: coins_1.CoinType.BTC,
        version: coins_1.CoinVersion.BTC,
        decimals: 8,
        formatDecimals: 8,
        blockchain: definitions_1.Blockchain.BITCOIN
    },
    {
        name: 'Ethereum',
        ticker: definitions_1.Ticker.ETH,
        type: coins_1.CoinType.ETH,
        version: coins_1.CoinVersion.ETH,
        decimals: 18,
        formatDecimals: 8,
        blockchain: definitions_1.Blockchain.ETHEREUM
    },
    {
        name: 'BNB',
        ticker: definitions_1.Ticker.BNB,
        type: coins_1.CoinType.ETH,
        version: coins_1.CoinVersion.ETH,
        decimals: 18,
        formatDecimals: 8,
        blockchain: definitions_1.Blockchain.BINANCE_SMART_CHAIN
    },
    {
        name: 'TRON',
        ticker: definitions_1.Ticker.TRX,
        type: coins_1.CoinType.TRX,
        version: coins_1.CoinVersion.TRX,
        decimals: 6,
        formatDecimals: 6,
        blockchain: definitions_1.Blockchain.TRON
    },
    {
        name: 'Polygon',
        ticker: definitions_1.Ticker.MATIC,
        type: coins_1.CoinType.ETH,
        version: coins_1.CoinVersion.ETH,
        decimals: 18,
        formatDecimals: 8,
        blockchain: definitions_1.Blockchain.POLYGON
    }
].map((c) => (Object.assign(Object.assign({}, c), { logoURL: (0, logo_1.getTickerLogoURL)(c.ticker) })));
exports.EthTokens = [
    {
        name: 'Tether USD',
        ticker: definitions_1.Ticker.USDT,
        address: {
            [network_1.Network.main]: '0xdac17f958d2ee523a2206206994597c13d831ec7',
            [network_1.Network.test]: '0x8C8D8157f262ADf1b8f8ed32864223eA0E26518e'
        },
        decimals: 6,
        formatDecimals: 2
    },
    {
        name: 'HEX',
        ticker: definitions_1.Ticker.HEX,
        address: {
            [network_1.Network.main]: '0x2b591e99afe9f32eaa6214f7b7629768c40eeb39',
            [network_1.Network.test]: '0x8C8D8157f262ADf1b8f8ed32864223eA0E26518e'
        },
        decimals: 8,
        formatDecimals: 8
    },
    {
        name: 'USD Coin',
        ticker: definitions_1.Ticker.USDC,
        address: {
            [network_1.Network.main]: '0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48',
            [network_1.Network.test]: '0x8C8D8157f262ADf1b8f8ed32864223eA0E26518e'
        },
        decimals: 6,
        formatDecimals: 2
    },
    {
        name: 'ChainLink Token',
        ticker: definitions_1.Ticker.LINK,
        address: {
            [network_1.Network.main]: '0x514910771af9ca656af840dff83e8264ecf986ca',
            [network_1.Network.test]: '0x9ec844b78ee884ec9f91771929f9cb199cd21249'
        },
        decimals: 18,
        formatDecimals: 8
    },
    {
        name: 'Binance USD',
        ticker: definitions_1.Ticker.BUSD,
        address: {
            [network_1.Network.main]: '0x4fabb145d64652a948d72533023f6e7a623c7c53',
            [network_1.Network.test]: '0x8C8D8157f262ADf1b8f8ed32864223eA0E26518e'
        },
        decimals: 18,
        formatDecimals: 2
    },
    {
        name: 'Wrapped BTC',
        ticker: definitions_1.Ticker.WBTC,
        address: {
            [network_1.Network.main]: '0x2260fac5e5542a773aa44fbcfedf7c193bc2c599',
            [network_1.Network.test]: '0x8C8D8157f262ADf1b8f8ed32864223eA0E26518e'
        },
        decimals: 8,
        formatDecimals: 8
    },
    {
        name: 'Uniswap',
        ticker: definitions_1.Ticker.UNI,
        address: {
            [network_1.Network.main]: '0x1f9840a85d5af5bf1d1762f925bdaddc4201f984',
            [network_1.Network.test]: '0x8C8D8157f262ADf1b8f8ed32864223eA0E26518e'
        },
        decimals: 18,
        formatDecimals: 8
    },
    {
        name: '1INCH Token',
        ticker: definitions_1.Ticker['1INCH'],
        address: {
            [network_1.Network.main]: '0x111111111117dC0aa78b770fA6A738034120C302',
            [network_1.Network.test]: '0x8C8D8157f262ADf1b8f8ed32864223eA0E26518e'
        },
        decimals: 18,
        formatDecimals: 18
    },
    {
        name: 'Aave Token',
        ticker: definitions_1.Ticker.AAVE,
        address: {
            [network_1.Network.main]: '0x7Fc66500c84A76Ad7e9c93437bFc5Ac33E2DDaE9',
            [network_1.Network.test]: '0x8C8D8157f262ADf1b8f8ed32864223eA0E26518e'
        },
        decimals: 18,
        formatDecimals: 18
    },
    {
        name: 'Alien Worlds',
        ticker: definitions_1.Ticker.TLM,
        address: {
            [network_1.Network.main]: '0x888888848B652B3E3a0f34c96E00EEC0F3a23F72',
            [network_1.Network.test]: '0x8C8D8157f262ADf1b8f8ed32864223eA0E26518e'
        },
        decimals: 4,
        formatDecimals: 4
    },
    {
        name: 'Automata Network',
        ticker: definitions_1.Ticker.ATA,
        address: {
            [network_1.Network.main]: '0xa2120b9e674d3fc3875f415a7df52e382f141225',
            [network_1.Network.test]: '0x8C8D8157f262ADf1b8f8ed32864223eA0E26518e'
        },
        decimals: 18,
        formatDecimals: 18
    },
    {
        name: 'Chiliz',
        ticker: definitions_1.Ticker.CHZ,
        address: {
            [network_1.Network.main]: '0x3506424f91fd33084466f402d5d97f05f8e3b4af',
            [network_1.Network.test]: '0x8C8D8157f262ADf1b8f8ed32864223eA0E26518e'
        },
        decimals: 18,
        formatDecimals: 18
    },
    {
        name: 'Compound',
        ticker: definitions_1.Ticker.COMP,
        address: {
            [network_1.Network.main]: '0xc00e94cb662c3520282e6f5717214004a7f26888',
            [network_1.Network.test]: '0x8C8D8157f262ADf1b8f8ed32864223eA0E26518e'
        },
        decimals: 18,
        formatDecimals: 18
    },
    {
        name: 'Fantom',
        ticker: definitions_1.Ticker.FTM,
        address: {
            [network_1.Network.main]: '0x4E15361FD6b4BB609Fa63C81A2be19d873717870',
            [network_1.Network.test]: '0x8C8D8157f262ADf1b8f8ed32864223eA0E26518e'
        },
        decimals: 18,
        formatDecimals: 18
    },
    {
        name: 'The Graph',
        ticker: definitions_1.Ticker.GRT,
        address: {
            [network_1.Network.main]: '0xc944e90c64b2c07662a292be6244bdf05cda44a7',
            [network_1.Network.test]: '0x8C8D8157f262ADf1b8f8ed32864223eA0E26518e'
        },
        decimals: 18,
        formatDecimals: 18
    },
    {
        name: 'Kyber Network Crystal v2',
        ticker: definitions_1.Ticker.KNC,
        address: {
            [network_1.Network.main]: '0xdeFA4e8a7bcBA345F687a2f1456F5Edd9CE97202',
            [network_1.Network.test]: '0x8C8D8157f262ADf1b8f8ed32864223eA0E26518e'
        },
        decimals: 18,
        formatDecimals: 18
    },
    {
        name: 'Polygon',
        ticker: definitions_1.Ticker.MATIC,
        address: {
            [network_1.Network.main]: '0x7D1AfA7B718fb893dB30A3aBc0Cfc608AaCfeBB0',
            [network_1.Network.test]: '0x8C8D8157f262ADf1b8f8ed32864223eA0E26518e'
        },
        decimals: 18,
        formatDecimals: 18
    },
    {
        name: 'Ren',
        ticker: definitions_1.Ticker.REN,
        address: {
            [network_1.Network.main]: '0x408e41876cccdc0f92210600ef50372656052a38',
            [network_1.Network.test]: '0x8C8D8157f262ADf1b8f8ed32864223eA0E26518e'
        },
        decimals: 18,
        formatDecimals: 18
    },
    {
        name: 'Reserve Rights',
        ticker: definitions_1.Ticker.RSR,
        address: {
            [network_1.Network.main]: '0x320623b8e4ff03373931769a31fc52a4e78b5d70',
            [network_1.Network.test]: '0x8C8D8157f262ADf1b8f8ed32864223eA0E26518e'
        },
        decimals: 18,
        formatDecimals: 18
    },
    {
        name: 'Shiba Inu',
        ticker: definitions_1.Ticker.SHIB,
        address: {
            [network_1.Network.main]: '0x95aD61b0a150d79219dCF64E1E6Cc01f0B64C4cE',
            [network_1.Network.test]: '0x8C8D8157f262ADf1b8f8ed32864223eA0E26518e'
        },
        decimals: 18,
        formatDecimals: 18
    },
    {
        name: 'SushiSwap',
        ticker: definitions_1.Ticker.SUSHI,
        address: {
            [network_1.Network.main]: '0x6B3595068778DD592e39A122f4f5a5cF09C90fE2',
            [network_1.Network.test]: '0x8C8D8157f262ADf1b8f8ed32864223eA0E26518e'
        },
        decimals: 18,
        formatDecimals: 18
    },
    {
        name: 'Synthetix',
        ticker: definitions_1.Ticker.SNX,
        address: {
            [network_1.Network.main]: '0xC011a73ee8576Fb46F5E1c5751cA3B9Fe0af2a6F',
            [network_1.Network.test]: '0x8C8D8157f262ADf1b8f8ed32864223eA0E26518e'
        },
        decimals: 18,
        formatDecimals: 18
    },
    {
        name: 'TrueUSD',
        ticker: definitions_1.Ticker.TUSD,
        address: {
            [network_1.Network.main]: '0x0000000000085d4780B73119b644AE5ecd22b376',
            [network_1.Network.test]: '0x8C8D8157f262ADf1b8f8ed32864223eA0E26518e'
        },
        decimals: 18,
        formatDecimals: 18
    },
    {
        name: 'yearn.finance',
        ticker: definitions_1.Ticker.YFI,
        address: {
            [network_1.Network.main]: '0x0bc529c00C6401aEF6D220BE8C6Ea1667F6Ad93e',
            [network_1.Network.test]: '0x8C8D8157f262ADf1b8f8ed32864223eA0E26518e'
        },
        decimals: 18,
        formatDecimals: 18
    },
    {
        name: 'PLANET',
        ticker: definitions_1.Ticker.PLA,
        address: {
            [network_1.Network.main]: '0x307d45Afbb7E84F82ef3D251A6bb0F00Edf632E4',
            [network_1.Network.test]: '0x6E2d1f2Dcf08df8A558e8D2f2a784bceA90403EC'
        },
        decimals: 18,
        formatDecimals: 8
    },
    {
        name: 'ZEDXIONC',
        ticker: definitions_1.Ticker.ZEDXIONC,
        address: {
            [network_1.Network.main]: '0xFbC4f3f645C4003a2E4F4e9b51077d2DaA9a9341',
            [network_1.Network.test]: '0x8C8D8157f262ADf1b8f8ed32864223eA0E26518e'
        },
        decimals: 18,
        formatDecimals: 18
    },
    {
        name: 'ZEDXION',
        ticker: definitions_1.Ticker.ZEDXION,
        address: {
            [network_1.Network.main]: '0xbAFDabaDcf19d0cFbbe0AB9C69CF050D86ff888C',
            [network_1.Network.test]: '0x8C8D8157f262ADf1b8f8ed32864223eA0E26518e'
        },
        decimals: 18,
        formatDecimals: 18
    },
    {
        name: 'Immutable X',
        ticker: definitions_1.Ticker.IMX,
        address: {
            [network_1.Network.main]: '0xf57e7e7c23978c3caec3c3548e3d615c346e79ff',
            [network_1.Network.test]: '0x8C8D8157f262ADf1b8f8ed32864223eA0E26518e'
        },
        decimals: 18,
        formatDecimals: 18
    },
    {
        name: 'Curve DAO Token',
        ticker: definitions_1.Ticker.CRV,
        address: {
            [network_1.Network.main]: '0xd533a949740bb3306d119cc777fa900ba034cd52',
            [network_1.Network.test]: '0x8C8D8157f262ADf1b8f8ed32864223eA0E26518e'
        },
        decimals: 18,
        formatDecimals: 18
    },
    {
        name: 'ApeCoin',
        ticker: definitions_1.Ticker.APE,
        address: {
            [network_1.Network.main]: '0x4d224452801ACEd8B2F0aebE155379bb5D594381',
            [network_1.Network.test]: '0x8C8D8157f262ADf1b8f8ed32864223eA0E26518e'
        },
        decimals: 18,
        formatDecimals: 18
    },
    {
        name: 'dYdX',
        ticker: definitions_1.Ticker.DYDX,
        address: {
            [network_1.Network.main]: '0x92D6C1e31e14520e676a687F0a93788B716BEff5',
            [network_1.Network.test]: '0x8C8D8157f262ADf1b8f8ed32864223eA0E26518e'
        },
        decimals: 18,
        formatDecimals: 18
    },
    {
        name: 'Litentry',
        ticker: definitions_1.Ticker.LIT,
        address: {
            [network_1.Network.main]: '0xb59490aB09A0f526Cc7305822aC65f2Ab12f9723',
            [network_1.Network.test]: '0x8C8D8157f262ADf1b8f8ed32864223eA0E26518e'
        },
        decimals: 18,
        formatDecimals: 18
    },
    {
        name: 'SAND',
        ticker: definitions_1.Ticker.SAND,
        address: {
            [network_1.Network.main]: '0x3845badAde8e6dFF049820680d1F14bD3903a5d0',
            [network_1.Network.test]: '0x8C8D8157f262ADf1b8f8ed32864223eA0E26518e'
        },
        decimals: 18,
        formatDecimals: 18
    },
    {
        name: 'Stater',
        ticker: definitions_1.Ticker.STR,
        address: {
            [network_1.Network.main]: '0x84bb947fcedba6b9c7dcead42df07e113bb03007',
            [network_1.Network.test]: '0x8C8D8157f262ADf1b8f8ed32864223eA0E26518e'
        },
        decimals: 18,
        formatDecimals: 18
    },
    {
        name: 'Pepe',
        ticker: definitions_1.Ticker.PEPE,
        address: {
            [network_1.Network.main]: '0x6982508145454Ce325dDbE47a25d4ec3d2311933',
            [network_1.Network.test]: '0x6982508145454Ce325dDbE47a25d4ec3d2311933'
        },
        decimals: 18,
        formatDecimals: 18
    }
].map((t) => (Object.assign(Object.assign({}, t), { logoURL: (0, logo_1.getTickerLogoURL)(t.ticker), coinTicker: definitions_1.Ticker.ETH, blockchain: definitions_1.Blockchain.ETHEREUM })));
exports.BscTokens = [
    {
        name: 'Binance USD',
        ticker: definitions_1.Ticker.BUSD,
        address: {
            [network_1.Network.main]: '0xe9e7CEA3DedcA5984780Bafc599bD69ADd087D56',
            [network_1.Network.test]: '0x8301F2213c0eeD49a7E28Ae4c3e91722919B8B47'
        },
        decimals: 18,
        formatDecimals: 2
    },
    {
        name: 'LocalTrade LTT',
        ticker: definitions_1.Ticker.LTT,
        address: {
            [network_1.Network.main]: '0x1DC84Fc11E48aE640D48044F22A603BBE914A612',
            [network_1.Network.test]: '0x1DC84Fc11E48aE640D48044F22A603BBE914A612'
        },
        decimals: 9,
        formatDecimals: 8
    },
    {
        name: 'SaverToken SVR',
        ticker: definitions_1.Ticker.SVR,
        address: {
            [network_1.Network.main]: '0xF599eF4aAEC7462E685C783079Baa3c433f0F6D5',
            [network_1.Network.test]: '0xF599eF4aAEC7462E685C783079Baa3c433f0F6D5'
        },
        decimals: 18,
        formatDecimals: 18
    },
    {
        name: 'Moonlight Token MOLT',
        ticker: definitions_1.Ticker.MOLT,
        address: {
            [network_1.Network.main]: '0x631147f85ccab2205063f52375de3633313b86f8',
            [network_1.Network.test]: '0x631147f85ccab2205063f52375de3633313b86f8'
        },
        decimals: 18,
        formatDecimals: 18
    },
    {
        name: 'Homeless HLS',
        ticker: definitions_1.Ticker.HLS,
        address: {
            [network_1.Network.main]: '0x299F467665e1870A705099AA5a0F11520df026bC',
            [network_1.Network.test]: '0x299F467665e1870A705099AA5a0F11520df026bC'
        },
        decimals: 18,
        formatDecimals: 18
    },
    {
        name: 'DONR DONR',
        ticker: definitions_1.Ticker.DONR,
        address: {
            [network_1.Network.main]: '0x1D36E7a4988032aa953CC467329c6e0e910a0b46',
            [network_1.Network.test]: '0x1D36E7a4988032aa953CC467329c6e0e910a0b46'
        },
        decimals: 9,
        formatDecimals: 9
    },
    {
        name: 'INTDESTCOIN',
        ticker: definitions_1.Ticker.INTD,
        address: {
            [network_1.Network.main]: '0x8Bb93979901cd159bF6763B223FBb315C31CCF7b',
            [network_1.Network.test]: '0x8Bb93979901cd159bF6763B223FBb315C31CCF7b'
        },
        decimals: 18,
        formatDecimals: 9
    },
    {
        name: 'INTDESTCOIN',
        ticker: definitions_1.Ticker.INTDv1,
        address: {
            [network_1.Network.main]: '0xb08ba4ad6bc291f4f1e79c4c7f9395141b8d5797',
            [network_1.Network.test]: '0xb08ba4ad6bc291f4f1e79c4c7f9395141b8d5797'
        },
        decimals: 18,
        formatDecimals: 9
    },
    {
        name: 'Aave Token',
        ticker: definitions_1.Ticker.AAVE,
        address: {
            [network_1.Network.main]: '0xfb6115445Bff7b52FeB98650C87f44907E58f802',
            [network_1.Network.test]: '0xfb6115445Bff7b52FeB98650C87f44907E58f802'
        },
        decimals: 18,
        formatDecimals: 18
    },
    {
        name: '1INCH Token',
        ticker: definitions_1.Ticker['1INCH'],
        address: {
            [network_1.Network.main]: '0x111111111117dC0aa78b770fA6A738034120C302',
            [network_1.Network.test]: '0x111111111117dC0aa78b770fA6A738034120C302'
        },
        decimals: 18,
        formatDecimals: 18
    },
    {
        name: 'Alien Worlds',
        ticker: definitions_1.Ticker.TLM,
        address: {
            [network_1.Network.main]: '0x2222227E22102Fe3322098e4CBfE18cFebD57c95',
            [network_1.Network.test]: '0x2222227E22102Fe3322098e4CBfE18cFebD57c95'
        },
        decimals: 4,
        formatDecimals: 4
    },
    {
        name: 'Automata Network',
        ticker: definitions_1.Ticker.ATA,
        address: {
            [network_1.Network.main]: '0xa2120b9e674d3fc3875f415a7df52e382f141225',
            [network_1.Network.test]: '0xa2120b9e674d3fc3875f415a7df52e382f141225'
        },
        decimals: 18,
        formatDecimals: 18
    },
    {
        name: 'BakeryToken',
        ticker: definitions_1.Ticker.BAKE,
        address: {
            [network_1.Network.main]: '0xE02dF9e3e622DeBdD69fb838bB799E3F168902c5',
            [network_1.Network.test]: '0xE02dF9e3e622DeBdD69fb838bB799E3F168902c5'
        },
        decimals: 18,
        formatDecimals: 18
    },
    {
        name: 'Binance-Peg Bitcoin Cash Token',
        ticker: definitions_1.Ticker.BCH,
        address: {
            [network_1.Network.main]: '0x8fF795a6F4D97E7887C79beA79aba5cc76444aDf',
            [network_1.Network.test]: '0x8fF795a6F4D97E7887C79beA79aba5cc76444aDf'
        },
        decimals: 18,
        formatDecimals: 18
    },
    {
        name: 'Binance-Peg Cardano Token',
        ticker: definitions_1.Ticker.ADA,
        address: {
            [network_1.Network.main]: '0x3ee2200efb3400fabb9aacf31297cbdd1d435d47',
            [network_1.Network.test]: '0x3ee2200efb3400fabb9aacf31297cbdd1d435d47'
        },
        decimals: 18,
        formatDecimals: 18
    },
    {
        name: 'Compound',
        ticker: definitions_1.Ticker.COMP,
        address: {
            [network_1.Network.main]: '0x52ce071bd9b1c4b00a0b92d298c512478cad67e8',
            [network_1.Network.test]: '0x52ce071bd9b1c4b00a0b92d298c512478cad67e8'
        },
        decimals: 18,
        formatDecimals: 18
    },
    {
        name: 'Binance-Peg Dogecoin Token',
        ticker: definitions_1.Ticker.DOGE,
        address: {
            [network_1.Network.main]: '0xba2ae424d960c26247dd6c32edc70b295c744c43',
            [network_1.Network.test]: '0xba2ae424d960c26247dd6c32edc70b295c744c43'
        },
        decimals: 8,
        formatDecimals: 8
    },
    {
        name: 'Fantom',
        ticker: definitions_1.Ticker.FTM,
        address: {
            [network_1.Network.main]: '0xad29abb318791d579433d831ed122afeaf29dcfe',
            [network_1.Network.test]: '0xad29abb318791d579433d831ed122afeaf29dcfe'
        },
        decimals: 18,
        formatDecimals: 18
    },
    {
        name: 'Kyber Network Crystal v2',
        ticker: definitions_1.Ticker.KNC,
        address: {
            [network_1.Network.main]: '0xfe56d5892bdffc7bf58f2e84be1b2c32d21c308b',
            [network_1.Network.test]: '0xfe56d5892bdffc7bf58f2e84be1b2c32d21c308b'
        },
        decimals: 18,
        formatDecimals: 18
    },
    {
        name: 'Litecoin',
        ticker: definitions_1.Ticker.LTC,
        address: {
            [network_1.Network.main]: '0x4338665CBB7B2485A8855A139b75D5e34AB0DB94',
            [network_1.Network.test]: '0x4338665CBB7B2485A8855A139b75D5e34AB0DB94'
        },
        decimals: 18,
        formatDecimals: 18
    },
    {
        name: 'Polygon',
        ticker: definitions_1.Ticker.MATIC,
        address: {
            [network_1.Network.main]: '0xcc42724c6683b7e57334c4e856f4c9965ed682bd',
            [network_1.Network.test]: '0xcc42724c6683b7e57334c4e856f4c9965ed682bd'
        },
        decimals: 18,
        formatDecimals: 18
    },
    {
        name: 'PancakeSwap',
        ticker: definitions_1.Ticker.CAKE,
        address: {
            [network_1.Network.main]: '0x0e09fabb73bd3ade0a17ecc321fd13a19e81ce82',
            [network_1.Network.test]: '0x0e09fabb73bd3ade0a17ecc321fd13a19e81ce82'
        },
        decimals: 18,
        formatDecimals: 18
    },
    {
        name: 'Polkadot',
        ticker: definitions_1.Ticker.DOT,
        address: {
            [network_1.Network.main]: '0x7083609fCE4d1d8Dc0C979AAb8c869Ea2C873402',
            [network_1.Network.test]: '0x7083609fCE4d1d8Dc0C979AAb8c869Ea2C873402'
        },
        decimals: 18,
        formatDecimals: 18
    },
    {
        name: 'Binance-Peg XRP',
        ticker: definitions_1.Ticker.XRP,
        address: {
            [network_1.Network.main]: '0x1D2F0da169ceB9fC7B3144628dB156f3F6c60dBE',
            [network_1.Network.test]: '0x1D2F0da169ceB9fC7B3144628dB156f3F6c60dBE'
        },
        decimals: 18,
        formatDecimals: 18
    },
    {
        name: 'SafePal',
        ticker: definitions_1.Ticker.SFP,
        address: {
            [network_1.Network.main]: '0xd41fdb03ba84762dd66a0af1a6c8540ff1ba5dfb',
            [network_1.Network.test]: '0xd41fdb03ba84762dd66a0af1a6c8540ff1ba5dfb'
        },
        decimals: 18,
        formatDecimals: 18
    },
    {
        name: 'Shiba Inu',
        ticker: definitions_1.Ticker.SHIB,
        address: {
            [network_1.Network.main]: '0x2859e4544C4bB03966803b044A93563Bd2D0DD4D',
            [network_1.Network.test]: '0x2859e4544C4bB03966803b044A93563Bd2D0DD4D'
        },
        decimals: 18,
        formatDecimals: 18
    },
    {
        name: 'SushiSwap',
        ticker: definitions_1.Ticker.SUSHI,
        address: {
            [network_1.Network.main]: '0x947950BcC74888a40Ffa2593C5798F11Fc9124C4',
            [network_1.Network.test]: '0x947950BcC74888a40Ffa2593C5798F11Fc9124C4'
        },
        decimals: 18,
        formatDecimals: 18
    },
    {
        name: 'Synthetix',
        ticker: definitions_1.Ticker.SNX,
        address: {
            [network_1.Network.main]: '0x9Ac983826058b8a9C7Aa1C9171441191232E8404',
            [network_1.Network.test]: '0x9Ac983826058b8a9C7Aa1C9171441191232E8404'
        },
        decimals: 18,
        formatDecimals: 18
    },
    {
        name: 'Trust Wallet',
        ticker: definitions_1.Ticker.TWT,
        address: {
            [network_1.Network.main]: '0x4B0F1812e5Df2A09796481Ff14017e6005508003',
            [network_1.Network.test]: '0x4B0F1812e5Df2A09796481Ff14017e6005508003'
        },
        decimals: 18,
        formatDecimals: 18
    },
    {
        name: 'VeChain',
        ticker: definitions_1.Ticker.VET,
        address: {
            [network_1.Network.main]: '0x6FDcdfef7c496407cCb0cEC90f9C5Aaa1Cc8D888',
            [network_1.Network.test]: '0x6FDcdfef7c496407cCb0cEC90f9C5Aaa1Cc8D888'
        },
        decimals: 18,
        formatDecimals: 18
    },
    {
        name: 'yearn.finance',
        ticker: definitions_1.Ticker.YFI,
        address: {
            [network_1.Network.main]: '0x88f1A5ae2A3BF98AEAF342D26B30a79438c9142e',
            [network_1.Network.test]: '0x88f1A5ae2A3BF98AEAF342D26B30a79438c9142e'
        },
        decimals: 18,
        formatDecimals: 18
    },
    {
        name: 'USD Coin',
        ticker: definitions_1.Ticker.USDC,
        address: {
            [network_1.Network.main]: '0x8AC76a51cc950d9822D68b83fE1Ad97B32Cd580d',
            [network_1.Network.test]: '0x8AC76a51cc950d9822D68b83fE1Ad97B32Cd580d'
        },
        decimals: 18,
        formatDecimals: 2
    },
    {
        name: 'Tether USD',
        ticker: definitions_1.Ticker.USDT,
        address: {
            [network_1.Network.main]: '0x55d398326f99059fF775485246999027B3197955',
            [network_1.Network.test]: '0x55d398326f99059fF775485246999027B3197955'
        },
        decimals: 18,
        formatDecimals: 2
    },
    {
        name: 'Volt Inu',
        ticker: definitions_1.Ticker.VOLT,
        address: {
            [network_1.Network.main]: '0x7db5af2B9624e1b3B4Bb69D6DeBd9aD1016A58Ac',
            [network_1.Network.test]: '0x7db5af2B9624e1b3B4Bb69D6DeBd9aD1016A58Ac'
        },
        decimals: 9,
        formatDecimals: 2
    },
    {
        name: 'ZEDXIONC',
        ticker: definitions_1.Ticker.ZEDXIONC,
        address: {
            [network_1.Network.main]: '0xfbc4f3f645c4003a2e4f4e9b51077d2daa9a9341',
            [network_1.Network.test]: '0xfbc4f3f645c4003a2e4f4e9b51077d2daa9a9341'
        },
        decimals: 18,
        formatDecimals: 18
    },
    {
        name: 'ZEDXION',
        ticker: definitions_1.Ticker.ZEDXION,
        address: {
            [network_1.Network.main]: '0xff44967f2E4EBE0b8c5b6812f25e1b9BceC70b34',
            [network_1.Network.test]: '0xff44967f2E4EBE0b8c5b6812f25e1b9BceC70b34'
        },
        decimals: 18,
        formatDecimals: 18
    },
    {
        name: 'USDZ',
        ticker: definitions_1.Ticker.USDZ,
        address: {
            [network_1.Network.main]: '0x734D66f635523D7ddb7d2373C128333DA313041b',
            [network_1.Network.test]: '0x734D66f635523D7ddb7d2373C128333DA313041b'
        },
        decimals: 9,
        formatDecimals: 9
    },
    {
        name: 'Toman IRR',
        ticker: definitions_1.Ticker.IRR,
        address: {
            [network_1.Network.main]: '0x7A532Aa9A2Ab86f6BD7E1Dcd93d3FdD2B0B410a6',
            [network_1.Network.test]: '0x7A532Aa9A2Ab86f6BD7E1Dcd93d3FdD2B0B410a6'
        },
        decimals: 4,
        formatDecimals: 4
    },
    {
        name: 'Cosmos',
        ticker: definitions_1.Ticker.ATOM,
        address: {
            [network_1.Network.main]: '0x0eb3a705fc54725037cc9e008bdede697f62f335',
            [network_1.Network.test]: '0x0eb3a705fc54725037cc9e008bdede697f62f335'
        },
        decimals: 18,
        formatDecimals: 18
    },
    {
        name: 'NEAR Protocol',
        ticker: definitions_1.Ticker.NEAR,
        address: {
            [network_1.Network.main]: '0x1fa4a73a3f0133f0025378af00236f3abdee5d63',
            [network_1.Network.test]: '0x1fa4a73a3f0133f0025378af00236f3abdee5d63'
        },
        decimals: 18,
        formatDecimals: 18
    },
    {
        name: 'Green Metaverse Token',
        ticker: definitions_1.Ticker.GMT,
        address: {
            [network_1.Network.main]: '0x3019BF2a2eF8040C242C9a4c5c4BD4C81678b2A1',
            [network_1.Network.test]: '0x3019BF2a2eF8040C242C9a4c5c4BD4C81678b2A1'
        },
        decimals: 8,
        formatDecimals: 8
    },
    {
        name: 'SolarBlox',
        ticker: definitions_1.Ticker.SBX,
        address: {
            [network_1.Network.main]: '0x54920Fe5963d481350d0C5a89BAA19c885460139',
            [network_1.Network.test]: '0x54920Fe5963d481350d0C5a89BAA19c885460139'
        },
        decimals: 18,
        formatDecimals: 18
    },
    {
        name: 'Funex',
        ticker: definitions_1.Ticker.FUNEX,
        address: {
            [network_1.Network.main]: '0xa07C39f8dF11cA675f77EfC19501e3Dddacd03Ed',
            [network_1.Network.test]: '0xa07C39f8dF11cA675f77EfC19501e3Dddacd03Ed'
        },
        decimals: 18,
        formatDecimals: 18
    },
    {
        name: 'Shiba Forest',
        ticker: definitions_1.Ticker.SHF,
        address: {
            [network_1.Network.main]: '0x058F54Ec846cf0fe82C06a03D63c2aec62fE0b82',
            [network_1.Network.test]: '0x058F54Ec846cf0fe82C06a03D63c2aec62fE0b82'
        },
        decimals: 18,
        formatDecimals: 18
    },
    {
        name: 'Own Just Shares',
        ticker: definitions_1.Ticker.OJS,
        address: {
            [network_1.Network.main]: '0xac9a17b13b8E86f75EC09AF4d39fB7eEA52ea845',
            [network_1.Network.test]: '0xac9a17b13b8E86f75EC09AF4d39fB7eEA52ea845'
        },
        decimals: 18,
        formatDecimals: 18
    },
    {
        name: 'Tegro',
        ticker: definitions_1.Ticker.TGR,
        address: {
            [network_1.Network.main]: '0xd9780513292477C4039dFdA1cfCD89Ff111e9DA5',
            [network_1.Network.test]: '0xd9780513292477C4039dFdA1cfCD89Ff111e9DA5'
        },
        decimals: 18,
        formatDecimals: 18
    },
    {
        name: 'CRED COIN PAY',
        ticker: definitions_1.Ticker.CRED,
        address: {
            [network_1.Network.main]: '0xFc76ba9157Ee5D079De8c1e969ee54096Aaa6C9c',
            [network_1.Network.test]: '0xFc76ba9157Ee5D079De8c1e969ee54096Aaa6C9c'
        },
        decimals: 18,
        formatDecimals: 18
    }
].map((t) => (Object.assign(Object.assign({}, t), { logoURL: (0, logo_1.getTickerLogoURL)(t.ticker), coinTicker: definitions_1.Ticker.BNB, blockchain: definitions_1.Blockchain.BINANCE_SMART_CHAIN })));
exports.TronTokens = [
    {
        name: 'Tether USD',
        ticker: definitions_1.Ticker.USDT,
        address: {
            [network_1.Network.main]: 'TR7NHqjeKQxGTCi8q8ZY4pL8otSzgjLj6t',
            [network_1.Network.test]: 'TW1sRrH1i7ZhA7nZRPP3P6fLUtgE5SiRr3'
        },
        decimals: 6,
        formatDecimals: 2
    },
    {
        name: 'ZEDXIONC',
        ticker: definitions_1.Ticker.ZEDXIONC,
        address: {
            [network_1.Network.main]: 'TMNTn2uFAHhkGE3uuM84rhfRRjt6ry9xnL',
            [network_1.Network.test]: 'TMNTn2uFAHhkGE3uuM84rhfRRjt6ry9xnL'
        },
        decimals: 18,
        formatDecimals: 18
    },
    {
        name: 'FUNEX',
        ticker: definitions_1.Ticker.FUNEX,
        address: {
            [network_1.Network.main]: 'TMYBRDphyekK3JR31RuthpUx6N8Qcj6Wao',
            [network_1.Network.test]: 'TMYBRDphyekK3JR31RuthpUx6N8Qcj6Wao'
        },
        decimals: 18,
        formatDecimals: 18
    },
    {
        name: 'Binance USD',
        ticker: definitions_1.Ticker.BUSD,
        address: {
            [network_1.Network.main]: 'TMz2SWatiAtZVVcH2ebpsbVtYwUPT9EdjH',
            [network_1.Network.test]: 'TMz2SWatiAtZVVcH2ebpsbVtYwUPT9EdjH'
        },
        abi: '[{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"owner","type":"address"},{"indexed":true,"internalType":"address","name":"spender","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Approval","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"caller","type":"address"},{"indexed":true,"internalType":"address","name":"from","type":"address"},{"indexed":false,"internalType":"uint256","name":"amount","type":"uint256"}],"name":"Burn","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"uint8","name":"version","type":"uint8"}],"name":"Initialized","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"caller","type":"address"},{"indexed":true,"internalType":"address","name":"to","type":"address"},{"indexed":false,"internalType":"uint256","name":"amount","type":"uint256"}],"name":"Mint","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"currentOwner","type":"address"},{"indexed":true,"internalType":"address","name":"proposedOwner","type":"address"}],"name":"OwnershipProposalCancelled","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"previousOwner","type":"address"},{"indexed":true,"internalType":"address","name":"proposedOwner","type":"address"}],"name":"OwnershipPulled","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"previousOwner","type":"address"},{"indexed":true,"internalType":"address","name":"proposedOwner","type":"address"}],"name":"OwnershipPushed","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"address","name":"account","type":"address"}],"name":"Paused","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"from","type":"address"},{"indexed":true,"internalType":"address","name":"to","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Transfer","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"address","name":"account","type":"address"}],"name":"Unpaused","type":"event"},{"inputs":[],"name":"DOMAIN_SEPARATOR","outputs":[{"internalType":"bytes32","name":"","type":"bytes32"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"owner","type":"address"},{"internalType":"address","name":"spender","type":"address"}],"name":"allowance","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"approve","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"account","type":"address"}],"name":"balanceOf","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"burn","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"cancelProposedOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"decimals","outputs":[{"internalType":"uint8","name":"","type":"uint8"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"subtractedValue","type":"uint256"}],"name":"decreaseAllowance","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"addedValue","type":"uint256"}],"name":"increaseAllowance","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"string","name":"_name","type":"string"},{"internalType":"string","name":"_symbol","type":"string"}],"name":"initialize","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"mint","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"name","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"owner","type":"address"}],"name":"nonces","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"owner","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"pause","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"paused","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"owner","type":"address"},{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"value","type":"uint256"},{"internalType":"uint256","name":"deadline","type":"uint256"},{"internalType":"uint8","name":"v","type":"uint8"},{"internalType":"bytes32","name":"r","type":"bytes32"},{"internalType":"bytes32","name":"s","type":"bytes32"}],"name":"permit","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"proposedOwner","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"pullOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"newOwner","type":"address"}],"name":"pushOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"symbol","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"totalSupply","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"transfer","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"from","type":"address"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"transferFrom","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"unpause","outputs":[],"stateMutability":"nonpayable","type":"function"}]',
        decimals: 18,
        formatDecimals: 2
    }
].map((t) => (Object.assign(Object.assign({}, t), { logoURL: (0, logo_1.getTickerLogoURL)(t.ticker), coinTicker: definitions_1.Ticker.TRX, blockchain: definitions_1.Blockchain.TRON })));
exports.PolygonTokens = [
    {
        name: 'USD Coin',
        ticker: definitions_1.Ticker.USDC,
        address: {
            [network_1.Network.main]: '0x3c499c542cEF5E3811e1192ce70d8cC03d5c3359',
            [network_1.Network.test]: '0x8C8D8157f262ADf1b8f8ed32864223eA0E26518e'
        },
        decimals: 6,
        formatDecimals: 2
    }
].map((t) => (Object.assign(Object.assign({}, t), { logoURL: (0, logo_1.getTickerLogoURL)(t.ticker), coinTicker: definitions_1.Ticker.MATIC, blockchain: definitions_1.Blockchain.POLYGON })));
exports.Fiats = [
    {
        name: 'US Dollar',
        ticker: definitions_1.Ticker.USD,
        symbol: '$',
        decimals: 2,
        formatDecimals: 2
    },
    {
        name: 'Ukrainian hryvnia',
        ticker: definitions_1.Ticker.UAH,
        symbol: '₴',
        decimals: 2,
        formatDecimals: 2
    },
    {
        name: 'Euro',
        ticker: definitions_1.Ticker.EUR,
        symbol: '€',
        decimals: 2,
        formatDecimals: 2
    },
    {
        name: 'Kazakhstani Tenge',
        ticker: definitions_1.Ticker.KZT,
        symbol: '₸',
        decimals: 2,
        formatDecimals: 2
    }
].map((f) => (Object.assign(Object.assign({}, f), { logoURL: (0, logo_1.getTickerLogoURL)(f.ticker) })));
exports.CryptoTokens = [
    ...exports.EthTokens,
    ...exports.BscTokens,
    ...exports.TronTokens,
    ...exports.PolygonTokens
];
exports.CryptoCurrencies = [...exports.Coins, ...exports.CryptoTokens];
exports.Currencies = [...exports.Fiats, ...exports.CryptoCurrencies];
exports.WalletApiCryptoCurrencies = exports.CryptoCurrencies.filter((c) => c.blockchain !== definitions_1.Blockchain.BITCOIN);
//# sourceMappingURL=data:application/json;base64,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